import React, { Component } from "react"
import { connect, Provider } from "react-redux"
import { AxiosResponse } from "axios"
import trans from "trans"

import { find, sortBy } from "lodash"

import {
    css,
    Div,
    Button,
    confirm,
    Theme,
    Message,
    Spinner,
    Icon,
    Grid,
    GridCell,
    modal,
} from "@bdfx/mergado-ui-kit"

import store from "store";
import {RouterType, withRouter} from "app/components/routes"
import {createToast} from "actions";
import toastFactory, {textToast} from "app/helpers/toast_factory";

import {AlternativeTemplate, AlternativeTemplatesLevels, Query, Template} from "app/types/model-types";

import {
    IMPORT_JSON_TEMPLATE,
    Templates,
    reorderTemplates,
    setTemplatesToStore,
    setSizesToStore,
    setAlternativeTemplatesLevelsToStore,
    setAlternativeTemplatesToStore,
} from "template-edit/reducers"

import {
    updateInputValue,
    initForm
} from "app/reducers/form";

import {
    projectId,
    eshopId,
    deleteTemplate,
    pauseTemplate,
    startTemplate,
    duplicateTemplate,
    startOrPauseTemplate,
    getTemplateDiagnostics,
    getQueries,
    importTemplate,
    getProjectSettings,
    toggleReorderTemplatesAutomatically,
    getWatermarkGroups,
    getInpaintingGroups,
    getSizes,
    getAlternativeTemplatesLevels,
    getTemplates,
    getAlternativeTemplates,
} from "app/helpers/api"

import newTemplate from "template-edit/helpers/newTemplate"
import {ID, intboolean, ReduxList} from "app/types/app-types"
import {FiltersFormType, emptyFiltersState} from "products/types/filtertypes";
import {setQueriesToStore} from "actions";
import {setWatermarkGroupsToStore, setInpaintingGroupsToStore} from "watermark-groups/reducers";

import {ShowGroupType} from "diagnostics/diagnostics";
import GallerySlideShow from "./gallery-slide-show";
import {URL} from "app/config/api-config";
import {UglyYellow} from "app/helpers/diagnostics";
import {RandomProduct} from "shape-edit/types";
import {SettingsFormType} from "app/types/model-types";
import {InpaintingGroupType, WatermarkGroupType} from "products/types";
import TemplatesTable from "./templates-table"
import { selectFormValues } from "app/reducers/form"
import { ExportsType, createTemplateExport, downloadTemplateExport } from "app/reducers/exports"
import NewTemplateModal from "app/components/new-template-modal-wrapper"
import { SizeItem } from "settings/components/sizes-settings"
import { ConfirmStyles } from "load_styles"
import { clearHistory } from "template-edit/undoRedoReducers"

export const MAX_FILE_SIZE = 10485760
export const ALLOWED_FILE_TYPES = [
    "application/json",
    "text/plain",
]

export type ActionType = 'export' | 'start' | 'pause' | 'copy' | 'delete' | 'rerender' | 'redownload'
export type FileInputType = {
    base64: string
    file: {
        name: string
        size: number
        type: string
        lastModified: number
        lastModifiedDate: string
        webkitRelativePath: string
    }
    name: string
    size: number
    type: string
}

interface Props {
    isAlt: boolean
    router: RouterType
    templates: Templates
    alternativeTemplates: ReduxList<AlternativeTemplate>
    randomProduct: RandomProduct
    reorderTemplates: typeof reorderTemplates
    setTemplatesToStore: typeof setTemplatesToStore
    setAlternativeTemplatesToStore: typeof setAlternativeTemplatesToStore
    setAlternativeTemplatesLevelsToStore: typeof setAlternativeTemplatesLevelsToStore
    setQueriesToStore: typeof setQueriesToStore
    setWatermarkGroupsToStore: typeof setWatermarkGroupsToStore
    setInpaintingGroupsToStore: typeof setInpaintingGroupsToStore
    initForm: typeof initForm
    clearHistory: typeof clearHistory
    setSizesToStore: typeof setSizesToStore
    filtersForm: FiltersFormType
    updateInputValue: typeof updateInputValue
    exportTemplates: ExportsType
    createTemplateExport: typeof createTemplateExport
    downloadTemplateExport: typeof downloadTemplateExport
}

interface State {
    isImporting: boolean
    filters: TemplateFilters
    autoPriority: intboolean
    thumbnails: TemplateThumbnails
    toasts: boolean
    editId: ID
    editType: TemplateEditType
}

export type TemplateEditType = "name" | "priority"

export type TemplateFilters = {
    name: string
    error: string
    active: intboolean
    dynamicOnly: intboolean
}

export type TemplateThumbnails = {
    images: string[]
    isLoading: boolean
    isLoaded: boolean
}

class TemplateList extends Component<Props, State> {
    public counter = 0

    constructor(props) {
        super(props)

        this.state = {
            isImporting: false,
            filters: {
                name: '',
                error: '',
                active: 1,
                dynamicOnly: 0,
            },
            thumbnails: null,
            toasts: false,
            autoPriority: null,
            editId: null,
            editType: null,
        }

        if(Object.keys(props.filtersForm).length === 0) {
            props.initForm("filtersForm",{ ...emptyFiltersState, ...props.filtersForm})
        }
    }

    handleDuplicate = (template) => {
        duplicateTemplate(template.id)
            .then((response: AxiosResponse<Template[]>) => {
                this.props.setTemplatesToStore(response.data)
            })
            .catch(error => {
                console.error('error while duplicating template', error)
            })
    }

    handleExport = (templateIds : number[]) => {
        this.props.createTemplateExport(templateIds, false)
    }

    confirmDelete = (template) => {
        confirm({
            message: trans("confirm_delete"),
            style: ConfirmStyles,
            buttons: [
                <Button key="yes" color={Theme.red}  onClick={() => this.handleDelete(template)}>{trans("yes")}</Button>,
                <Button key="no" color={Theme.green} onClick={() => false}>{trans("no")}</Button>
            ]
        })
    }

    updateLevels = () => {
        getAlternativeTemplatesLevels()
            .then((response: AxiosResponse<AlternativeTemplatesLevels[]>) => {
                this.props.setAlternativeTemplatesLevelsToStore(response.data)
            })
            .catch(e => {
                console.error('get alternative templates error', e)
            })
    }

    handleDelete = (template) => {
        this.counter++

        deleteTemplate(template)
            .then((response: any) => {
                this.props.setTemplatesToStore(response.data)
                this.counter--
                this.updateLevels()

            })
            .catch((error) => {
                console.log("Error when deleting template: ", error)
                this.counter--
            })
    }

    handleStartOrPause = (template) => {
        startOrPauseTemplate(template)
            .then((response: AxiosResponse<Template[]>) => {
                this.props.setTemplatesToStore(response.data)
                this.handleFilterActive(template.active ? 0 : 1)
            })
            .catch(error => {
                console.error("Error when pausing/starting template: ", error)
            })
    }

    handlePause = (template) => {
        this.counter++

        pauseTemplate(template)
            .then((response: AxiosResponse<Template[]>) => {
                this.props.setTemplatesToStore(response.data)
                this.counter--
            })
            .catch(error => {
                console.error("Error when pausing/starting template: ", error)
                this.counter--
            })
    }

    handleStart(template) {
        this.counter++
        startTemplate(template)
            .then((response: AxiosResponse<Template[]>) => {
                this.props.setTemplatesToStore(response.data)
                this.counter--
            })
            .catch(error => {
                console.error("Error when pausing/starting template: ", error)
                this.counter--
            })
    }

    confirmBulkDelete = () => confirm({
        message: trans("confirm__bulk_delete"),
        closeOnClickOutside: true,
        closeOnEscape: true,
        icon: <Icon type={'exclamation-triangle-radix'} color={Theme.red} />,
        style: ConfirmStyles,
        buttons: [
            <Button key="yes" color={Theme.red} onClick={() => this.handleBulkAction('delete')}>{trans("yes")}</Button>,
            <Button key="no" color={Theme.green} onClick={() => false}>{trans("no")}</Button>
        ]
    })

    handleBulkAction = (type) => {
        const checkboxes: any = document.getElementsByClassName('m-bulk-action-item')   //HTMLCollectionOf<any>
        const { exportTemplates, templates} = this.props

        if (type === 'export' && !exportTemplates.isExporting) {
            let templateIds = []
            for (const item of checkboxes) {
                const itemId = item.getAttribute("data-id")
                if (item.checked && itemId) {
                    const template = find(templates.data, (t: Template) => {
                        return `${t.id}` === item.getAttribute("data-id")
                    })

                    if (template) {
                        templateIds.push(template.id)
                    }
                }
            }

            if (templateIds.length) {
                this.handleExport(templateIds)
            }

            return;
        }

        for (const item of checkboxes) {
            if(item.checked) {
                const template = find(templates.data, (t: Template) => {
                    return `${t.id}` === item.getAttribute("data-id")
                })
                switch(type) {
                    case "start":
                        this.handleStart(template)
                        break
                    case "pause":
                        this.handlePause(template)
                        break
                    case "delete":
                        this.handleDelete(template)
                        break
                    case "copy":
                        this.handleDuplicate(template)
                        break;
                    default:
                        break
                }
            }
        }
    }

    updateSizes = () => {
        getSizes()
            .then((response: AxiosResponse<SizeItem[]>) => {
                this.props.setSizesToStore(response.data)
            })
            .catch(error => {
                console.error('error while getting queries', error)
            })
    }

    componentDidMount() {
        const { filters } = this.state

        //needed for initNewTemplateOrAltTemplateForm not from modal
        this.props.initForm('altTemplateForm', {})
        this.props.initForm('templateForm', {})
        this.props.clearHistory(null)

        getTemplates()
            .then((response: AxiosResponse<Template[]>) => {
                store.dispatch(setTemplatesToStore(response.data))
            })
            .catch(e => {
                console.error('get templates error', e)
            })

        getAlternativeTemplates()
            .then((response: AxiosResponse<AlternativeTemplate[]>) => {
                store.dispatch(setAlternativeTemplatesToStore(response.data))
            })
            .catch(e => {
                console.error('get alternative templates error', e)
            })

        getAlternativeTemplatesLevels()
            .then((response: AxiosResponse<AlternativeTemplatesLevels[]>) => {
                store.dispatch(setAlternativeTemplatesLevelsToStore(response.data))
            })
            .catch(e => {
                console.error('get alternative templates error', e)
            })

        getProjectSettings()
            .then((response: AxiosResponse<SettingsFormType>) => {
                this.setState({autoPriority: response.data.auto_template_priority})
            })
            .catch(error => {
                console.error('error while getting project settings', error)
            })

        getQueries()
            .then((response: AxiosResponse<Query[]>) => {
                this.props.setQueriesToStore(response.data)
            })
            .catch(error => {
                console.error('error while getting queries', error)
            })

        getWatermarkGroups()
            .then((response: AxiosResponse<WatermarkGroupType[]>) => {
                this.props.setWatermarkGroupsToStore(response.data)
            })
            .catch(e => {
                console.error('cannot get watermark groups', e)
            })

        getInpaintingGroups()
            .then((response: AxiosResponse<InpaintingGroupType[]>) => {
                this.props.setInpaintingGroupsToStore(response.data)
            })
            .catch(e => {
                console.error('cannot get inpainting groups', e)
            })
    }

    handleFilterName = (value: string) => {
        this.setState({
            filters: {
                ...this.state.filters,
                name: value
            },
        })
    }

    handleFilterActive = (value: intboolean) => {
        this.setState({
            filters: {
                ...this.state.filters,
                active: value
            },
        })
    }

    handleToggleAutoPriority = (evt) => {
        toggleReorderTemplatesAutomatically(evt)
            .then((response: AxiosResponse<Template[]>) => {
                store.dispatch(setTemplatesToStore(response.data))
            })
            .catch(error => {
                console.error('cannot reorder automatically', error)
            })
            .finally(() => {
                this.setState({autoPriority: evt})
            })
    }

    handleFilterDynamicOnly = (evt) => {
        this.setState({
            filters: {...this.state.filters, dynamicOnly: evt },
        })
    }

    setTemplateFilter = (templateId : ID, showGroup : ShowGroupType = 'unavailable', checkElementsAvailability: string[] = null) => {
        if (checkElementsAvailability === null) {
            this.props.initForm('filtersForm', {
                ...emptyFiltersState,
                image: {...emptyFiltersState.image, showGroup: [showGroup]},
                product: {...emptyFiltersState.product, template_id: templateId.toString()},
                //productsPerPage:  //getProductsPerPageOnList(),then .....
            })
        } else {
            this.props.initForm('filtersForm', {
                ...emptyFiltersState,
                image: {...emptyFiltersState.image},
                product: {
                    ...emptyFiltersState.product,
                    template_id: templateId.toString(),
                    check_elements_availability: Object.keys(checkElementsAvailability)
                },
            })
        }
    }

    handleCreateNewTemplate = () => {
        const template = newTemplate()
        this.props.initForm('templateForm', template)

        modal({
            maxWidth: "700px",
            overlayClassName: 'new-template-modal',
            title: trans("editor_step_0"),
            message: (close) => <NewTemplateModal close={close} />,
            closeOnEscape: true,
            closeOnClickOutside: true,
            hideCloseButton: true,
            onClose: () => this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}/templates/new`),
            style: {
                ' h3.muk-heading': {
                    textAlign: 'center',
                    fontSize: '1.8em',
                    marginTop: '.6em',
                },
                background: '#efefef',
            }
        })
    }

    handleReorderTemplates = (newOrder: string[]) => {
        if (!this.state.autoPriority) {
            this.props.reorderTemplates(newOrder, this.props.templates)
        }
    }

    hideToast = (type) => () => {
        sessionStorage.setItem('hide_toast_'+type, "1")
        this.setState(s => ({ toasts: !s.toasts}))
        return true
    }

    importTemplate = (file: FileInputType, isAlt: boolean) => {
        this.setState({isImporting: true})
        console.debug(`start importing ${isAlt ? 'ALT' : 'MAIN'} template from file: ${file.type}, size: ${file.size}`)

        if (file.size <= MAX_FILE_SIZE && ALLOWED_FILE_TYPES.includes(file.type)) {
            importTemplate(file.base64, file.name, isAlt)
                .then((response: AxiosResponse<(Template|AlternativeTemplate)[]>) => {
                    store.dispatch(createToast(toastFactory(IMPORT_JSON_TEMPLATE.SUCCESS)))
                    this.updateSizes()
                    if (isAlt) {
                        this.props.setAlternativeTemplatesToStore(response.data)
                    } else {
                        this.props.setTemplatesToStore(response.data)
                    }
                    this.handleFilterActive(0)
                })
                .catch(error => {
                    console.error('cannot import template', error)
                    store.dispatch(createToast(toastFactory(IMPORT_JSON_TEMPLATE.ERROR, error.response)))
                })
                .finally(() => this.setState({isImporting: false}))
        } else {
            console.error(`Unsupported file: ${file.type}, size: ${file.size}`)
            if (!ALLOWED_FILE_TYPES.includes(file.type)) {
                store.dispatch(createToast(textToast('error', trans('unsupported_mime_type') + ' ' + file.type)))
            } else if (file.size <= MAX_FILE_SIZE) {
                store.dispatch(createToast(textToast('error', trans('unsupported_file_size') + ' ' + file.size)))
            }
            this.setState({isImporting: false})
            return false;
        }
    }

    setEdit = (templateId: ID, editType: TemplateEditType) => {
        this.setState({editId: templateId, editType: editType})
    }

    handleTemplatePriority = (templateId: number, newTemplateOrder: number) => {
        const ii = newTemplateOrder-1
        const templatelist = this.getSortedList()
        const oldOrder = templatelist.map(t => `${t.id}`).filter(i => `${i}` !== `${templateId}`)
        let newOrder = []
        oldOrder.forEach((id, i) => {
            if (i === ii) {
                newOrder.push(`${templateId}`)
            }
            newOrder.push(`${id}`)
        })
        //console.debug(`reordering template ${templateId} to position ${newTemplateOrder}`, oldOrder, newOrder, templatelist)
        this.handleReorderTemplates(newOrder)
    }

    getSortedList = () : Template[] => {
        return sortBy(this.props.templates.data, [(template) => {
            return new Number(template.priority)
        }]).filter(template => {
            if(this.state.filters.name !== "") {
                const filterName = this.state.filters.name.toLowerCase()
                const templateName = template.name.toLowerCase()
                if(filterName !== "" && templateName.indexOf(filterName) === -1) {
                    return false
                }
            }
            if(this.state.filters.active !== null) {
                const DateNow = Date.now()
                if (this.state.filters.active === 1) {
                    if ((template.active !== 1) || (template.active_from && template.active_from > DateNow) || (template.active_to && template.active_to < DateNow)) {
                        return false
                    }
                } else {
                    return !template.active
                }
            }
            if(this.state.filters.dynamicOnly === 1) {
                if(template.is_dynamic !== true) {
                    return false
                }
            }
            return true
        })
    }


    render() {
        const { templates } = this.props

        const activeTemplatesCount = this.props.templates && this.props.templates.data ? this.props.templates.data.filter(template => template.active).length : 0

        return (
            <React.Fragment>
                <StyledToastsGrid>
                    {templates.isLoaded ? <>
                        {this.props.templates.data.length === 0 && !sessionStorage.getItem('hide_toast_info_no_template') ?
                            <GridCell>
                                <Message type="warning" closeable={true} onClose={this.hideToast("info_no_template")} icon={<Icon type={'exclamation-triangle'} color={"warning"} size={ToastIconSize} />} >
                                    {trans("info_no_template")}
                                </Message>
                            </GridCell>
                        : this.props.templates.data.length > 0 && !templates.atLeastOneActive && !sessionStorage.getItem('hide_toast_info_no_active_template') &&
                            <GridCell>
                                <Message type="warning" closeable={true} onClose={this.hideToast("info_no_active_template")} icon={<Icon type={'exclamation-triangle'} color={"warning"} size={ToastIconSize} />}>
                                    {trans("info_no_active_template")}
                                </Message>
                            </GridCell>
                        }

                        {activeTemplatesCount > 0 && !sessionStorage.getItem('hide_toast_info_workshop') ?
                            <GridCell>
                                <Message type="info" closeable={true} onClose={this.hideToast("info_workshop")}
                                    icon={<Icon type={'book-opened-light'} color={Theme.blue} size={ToastIconSize}/>}>
                                    {trans('info_workshop')}
                                </Message>
                            </GridCell>
                        : null}
                        {activeTemplatesCount > 1 && !sessionStorage.getItem('hide_toast_info_apply_one_rule') ?
                            <GridCell>
                                <Message type="info" closeable={true} onClose={this.hideToast("info_apply_one_rule")}
                                    icon={<Icon type={'info-circle'} color={Theme.blue} size={ToastIconSize}/>}>
                                    {trans('info_apply_one_rule')}
                                </Message>
                            </GridCell>
                        : null}
                        {activeTemplatesCount === 0 && !sessionStorage.getItem('hide_toast_toast_online_call') ?
                            <GridCell>
                                <Message type="info" closeable={true} onClose={this.hideToast("toast_online_call")}
                                    icon={<img src={`${URL.publicPath}/img/call-bubble.svg`} width={ToastIconSize}/>}>
                                    {trans('toast_online_call')}
                                </Message>
                            </GridCell>
                        : null}
                    </>
                    : null }

                    {this.props.exportTemplates.isExporting ?
                    <GridCell>
                        <Message type="info" icon={<Spinner color="#009BA9" style={{verticalAlign: "middle" }}/>} closeable={false}>
                                {this.props.exportTemplates.isExported ?
                                <span>{trans('template_exported')}</span>
                                :
                                <Div padding="10px">
                                    {trans('please_wait_generating_export')}
                                </Div>
                            }
                        </Message>
                    </GridCell>
                    : null}
                </StyledToastsGrid>

                <TemplatesTable
                    importTemplate={this.importTemplate}
                    isImporting={this.state.isImporting}
                    handleCreateNewTemplate={this.handleCreateNewTemplate}
                    handleReorderTemplates={this.handleReorderTemplates}
                    handleTemplatePriority={this.handleTemplatePriority}
                />

                <Div marginTop="30px">
                    <GallerySlideShow
                        handleCreateNewTemplate={this.handleCreateNewTemplate}
                        showProductsPreview={templates.atLeastOneActive}
                        importTemplate={this.importTemplate}
                        isImporting={this.state.isImporting}
                    />
                </Div>
            </React.Fragment>
        )
    }
}

const StyledToastsGrid = css(Grid)({
    gridTemplateColumns: 'repeat(1fr)',
    '@media screen and (min-width: 501px)': {
        gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))',
    },
    gridTemplateRows: 'auto',
    gridGap: '0 20px',
    placeItems: 'stretch',
    webkitBoxAlign: 'stretch',
    gridAutoFlow: 'row',
    alignSelf: 'center',
    verticalAlign: 'middle',
    "> .muk-gridcell": {
        marginBottom: "20px",
    },
    ' .muk-grid.muk-toast__wrapper': {
        height: '100%',
        padding: 0,
        margin: 0,
    },
    ' div.yellow-color': {
        borderColor: UglyYellow,
    }
})

export const ToastIconSize = 30

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        templates: state.templates,
        alternativeTemplates: state.alternativeTemplates,
        randomProduct: state.randomProduct,
        filtersForm: selectFormValues(state,'filtersForm'),
        exportTemplates: state.exportTemplates,
    }
}

export default connect(mapStateToProps, {
    initForm,
    reorderTemplates,
    updateInputValue,
    clearHistory,
    downloadTemplateExport,
    createTemplateExport,
    setQueriesToStore,
    setTemplatesToStore,
    setAlternativeTemplatesToStore,
    setAlternativeTemplatesLevelsToStore,
    setWatermarkGroupsToStore,
    setInpaintingGroupsToStore,
    setSizesToStore,
})(withRouter(TemplateList));